module.exports = __webpack_public_path__ + "img/7553847.jpg";